/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InternalApiTransliterationResponse
 */
export interface InternalApiTransliterationResponse {
    /**
     * The original input text
     * @type {string}
     * @memberof InternalApiTransliterationResponse
     */
    original: string;
    /**
     * The transliterated text
     * @type {string}
     * @memberof InternalApiTransliterationResponse
     */
    transliterated: string;
}

/**
 * Check if a given object implements the InternalApiTransliterationResponse interface.
 */
export function instanceOfInternalApiTransliterationResponse(value: object): value is InternalApiTransliterationResponse {
    if (!('original' in value) || value['original'] === undefined) return false;
    if (!('transliterated' in value) || value['transliterated'] === undefined) return false;
    return true;
}

export function InternalApiTransliterationResponseFromJSON(json: any): InternalApiTransliterationResponse {
    return InternalApiTransliterationResponseFromJSONTyped(json, false);
}

export function InternalApiTransliterationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiTransliterationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'original': json['original'],
        'transliterated': json['transliterated'],
    };
}

export function InternalApiTransliterationResponseToJSON(json: any): InternalApiTransliterationResponse {
    return InternalApiTransliterationResponseToJSONTyped(json, false);
}

export function InternalApiTransliterationResponseToJSONTyped(value?: InternalApiTransliterationResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'original': value['original'],
        'transliterated': value['transliterated'],
    };
}

